/* eslint-disable operator-linebreak */
import React from 'react';
import useCopyCollection from '../../../hooks/Collection/useCopyCollection';
import useCopyPlaylist from '../../../hooks/Playlist/useCopyPlaylist';

const CopyModelModal = ({ type, id, setCopied }) => {
  const { copyPlaylistRequest, loading: loadingCopyPlaylist } =
    useCopyPlaylist(setCopied);
  const { copyCollectionRequest, loading: loadingCopyCollection } =
    useCopyCollection(setCopied);

  const fnMap = {
    collection: copyCollectionRequest,
    playlist: copyPlaylistRequest,
  };

  const shouldDisableButton = loadingCopyCollection || loadingCopyPlaylist;

  return (
    <div
      className="modal fade"
      id="copyModelModal"
      tabIndex="-1"
      role="dialog"
      aria-labelledby="invitesModal"
      aria-hidden="true"
    >
      <div className="modal-dialog modal-dialog-centered" role="document">
        <div className="modal-content">
          <div className="custom__modal__content bg__cello px-sm-32 px-74">
            <h6 className="text__fs-18 text__fw-200 text__white mt-20  mb-5 text__center lh-140">
              Someone has shared this {type} with you. Save a copy to "My {type}
              s"?
            </h6>

            <button
              className="button button__md button__green-meadow mx-auto mt-6"
              onClick={() => fnMap[type](id)}
              disabled={shouldDisableButton}
              data-dismiss="modal"
            >
              Save
            </button>
            <button
              className="button button__md button__cerise-dark mx-auto mt-6"
              data-dismiss="modal"
              disabled={shouldDisableButton}
            >
              Close
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CopyModelModal;
